import styled from 'styled-components';

export const PlansStyle = styled.div`
  min-height: 100%;
  padding: 32px 24px 48px;
  background: var(--body-bg);
  color: var(--white);

  @media (min-width: 1024px) {
    padding: 40px;
  }

  .btn-back {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 32px;
    padding: 0;
    border: 0;
    background: transparent;
    color: #a0a0a0;
    font-size: 14px;
    cursor: pointer;

    &:hover {
      color: var(--white);
    }
  }

  .inner {
    max-width: 1024px;
    margin: 0 auto;
  }

  .header {
    text-align: center;
    margin-bottom: 40px;

    h1 {
      margin: 0 0 24px;
      font-size: 30px;
      line-height: 36px;
      font-weight: 700;
      color: var(--white);
    }
  }

  .tab-btns {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 4px;
    border-radius: 999px;
    border: 1px solid #262626;
    background: #161616;

    .btn {
      padding: 6px 20px;
      border: 0;
      border-radius: 999px;
      background: transparent;
      color: #a0a0a0;
      font-size: 14px;
      font-weight: 500;
      text-transform: capitalize;
      cursor: pointer;
      transition: color 0.15s ease, background 0.15s ease;

      &:hover {
        color: var(--white);
      }

      &.active {
        background: var(--primary);
        color: var(--white);
      }
    }
  }

  .plan-wrap {
    display: grid;
    gap: 20px;

    @media (min-width: 768px) {
      grid-template-columns: repeat(3, 1fr);
    }
  }

  .plan-col {
    display: flex;
    flex-direction: column;
    padding: 24px;
    border-radius: 12px;
    background: #161616;
    border: 1px solid #262626;
    transition: border-color 0.15s ease;

    &:not(.current):hover {
      border-color: rgba(3, 160, 141, 0.4);
    }

    .title {
      display: block;
      margin: 0 0 4px;
      font-size: 18px;
      font-weight: 600;
      color: var(--white);
    }

    .desc {
      margin: 0;
      min-height: 40px;
      font-size: 14px;
      line-height: 20px;
      color: #a0a0a0;
    }

    .price-box {
      margin: 20px 0;

      .price {
        display: block;
        font-size: 36px;
        line-height: 40px;
        font-weight: 700;
        color: var(--white);
      }

      .text {
        display: block;
        margin-top: 4px;
        font-size: 12px;
        color: #707070;
      }
    }

    .plan-btn {
      width: 100%;
      margin-bottom: 24px;
      padding: 10px 16px;
      border-radius: 999px;
      border: 1px solid #262626;
      font-size: 14px;
      font-weight: 500;
      cursor: pointer;
      transition: opacity 0.15s ease, background 0.15s ease;

      &.current {
        background: rgba(255, 255, 255, 0.05);
        color: #808080;
        cursor: default;
      }

      &.cta {
        background: var(--primary);
        border-color: var(--primary);
        color: var(--white);

        &:hover {
          opacity: 0.9;
        }
      }
    }

    .feature-list {
      list-style: none;
      margin: auto 0 0;
      padding: 0;
      display: flex;
      flex-direction: column;
      gap: 12px;

      li {
        display: flex;
        align-items: flex-start;
        gap: 10px;
        font-size: 14px;
        line-height: 20px;
        color: #c8c8c8;

        .icon {
          flex-shrink: 0;
          margin-top: 2px;
          color: var(--primary);
        }
      }
    }
  }
`;
